import React from 'react';
import { render } from 'react-dom';
import { Footer } from './components/common/footer';
import {
  isTerminalRoute,
  nextStep,
  nextSteps,
  currentStep,
  isLastStep,
} from './state/step/step.selectors';
import { goToNext } from './state/step/step.actions';
import { stateGo } from './state/router/router.actions';
import { STATES } from './constants';
import {
  track,
  DISPLAY,
  CLICK,
  getAttributes,
} from '@updater-core/lib/tracker';
import { isFeatureEnabled } from '@updater-core/lib/optimizely';

const mountPoint = document.querySelector('#next-step-footer-mount-point');
export const mountFooter = (updStore) => {
  const goHome = () => updStore.dispatch(stateGo(STATES.DASHBOARD));
  const goToNextStep = (state) => updStore.dispatch(goToNext(nextStep(state)));
  let enabled;

  const unsubscribe = updStore.subscribe(async () => {
    const state = updStore.getState();
    const uuid = getAttributes()?.user?.uuid;

    if (!uuid) {
      return; // return early if no uuid, theres nothing to do.
    }

    if (typeof enabled === 'undefined') {
      enabled = await isFeatureEnabled('Next_Step_Footer');
    }

    const shouldShowFooter = isTerminalRoute(state) && enabled;
    const details = {
      currentStep: currentStep(state),
      nextStep: nextStep(state),
      nextSteps: nextSteps(state),
    };

    const isOnLastStep = isLastStep(state);

    if (shouldShowFooter) {
      track({
        verb: DISPLAY,
        object: 'next_step_footer',
        details,
      });
    }

    render(
      shouldShowFooter ? (
        <Footer
          isOnLastStep={isOnLastStep}
          onGoHome={() => {
            track({
              verb: CLICK,
              object: 'footer_home',
              details,
            });
            goHome();
          }}
          onNext={() => {
            track({
              verb: CLICK,
              object: 'footer_next_step',
              details,
            });
            goToNextStep(state);
          }}
        />
      ) : (
        ''
      ),
      mountPoint
    );
  });
  return {
    destroy: () => {
      unsubscribe();
      render(null, mountPoint);
    },
  };
};
